import React from 'react';
import { usePresentation } from '@/context/PresentationContext';
import { Eye } from '@phosphor-icons/react';

export default function PresentationBanner() {
    const { on, setPresentation } = usePresentation();
    if (!on) return null;
    return (
        <div
            data-testid="presentation-banner"
            className="w-full h-8 flex items-center justify-center gap-3 bg-[#F97316] text-white text-[11px] uppercase tracking-[0.22em] font-semibold"
        >
            <Eye size={13} weight="fill" /> Presentation mode on
            <button
                onClick={() => setPresentation(false)}
                data-testid="presentation-banner-turn-off"
                className="ml-2 rounded-full bg-white/20 hover:bg-white/30 px-2 py-0.5 text-[10px] normal-case tracking-normal"
            >
                Turn off
            </button>
        </div>
    );
}
